/**
 * Static option lists reused across the ProUni forms. The values are the exact
 * strings persisted on the backend (free-text fields), so keep them stable.
 */
export const UF_LIST: string[] = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

export const RESIDENCE_PROOF_TYPES: string[] = [
  'Conta de luz',
  'Conta de água',
  'Conta de telefone/internet',
  'Contrato de aluguel',
  'Declaração de residência',
  'Outro',
];

export const ACTIVITY_TYPES: string[] = [
  'Empregado (CLT)',
  'Autônomo(a)',
  'Empresário(a)',
  'Aposentado(a)/Pensionista',
  'Recebe auxílio do governo',
  'Desempregado(a)',
  'Estudante',
  'Outro',
];

export const CONTACT_METHODS: string[] = ['E-mail', 'WhatsApp'];

export const YES_LABEL = 'Sim';
export const NO_LABEL = 'Não';

/** Maps an optional boolean to the localized Yes/No select label ('' when unset). */
export function toYesNoLabel(value?: boolean): string {
  if (typeof value !== 'boolean') return '';
  return value ? YES_LABEL : NO_LABEL;
}
